/**
 * Patient Problem List and per-user COMMON diagnoses APIs.
 * PostgreSQL is the source of truth. localStorage is a cache only.
 */
import { api } from "@/lib/orgApi";

export async function listProblemList(patientId) {
  if (!patientId) return { initialized: false, items: [] };
  const { data } = await api.get(`/patients/${encodeURIComponent(patientId)}/problems`);
  return {
    initialized: data.initialized === true,
    items: data.items || [],
  };
}

export async function replaceProblemList(patientId, items) {
  if (!patientId) return [];
  const { data } = await api.put(`/patients/${encodeURIComponent(patientId)}/problems`, {
    items: items || [],
  });
  return data.items || [];
}

export async function listCommonDiagnoses() {
  const { data } = await api.get("/auth/me/common-diagnoses");
  return {
    initialized: data.initialized === true,
    items: data.items || [],
  };
}

export async function replaceCommonDiagnoses(items) {
  const { data } = await api.put("/auth/me/common-diagnoses", { items: items || [] });
  return data.items || [];
}
